export default __webpack_public_path__ + "static/media/3B069A_0_0.69b802e6.woff";